import { z } from "zod";

/**
 * Connection presets a workspace may pick in the shared connection settings.
 *
 * The ids live in their own module so the connection schema can accept them
 * without importing the preset table, which needs the connection schema's own
 * types.
 */
export const CONNECTION_PRESET_IDS = ["orbin-inference"] as const;

export type ConnectionPresetId = (typeof CONNECTION_PRESET_IDS)[number];

export const ConnectionPresetIdSchema = z.enum(CONNECTION_PRESET_IDS);
